// extracted by mini-css-extract-plugin
module.exports = {"notes-wrapper":"Notes_notes-wrapper___Qk19"};